import { Injectable } from '@angular/core';
import { FCM } from '@capacitor-community/fcm';
import {
  PushNotificationSchema,
  PushNotifications,
} from '@capacitor/push-notifications';
import { Capacitor } from '@capacitor/core';
// import { Howl } from 'howler';
import { ToastController, NavController } from '@ionic/angular';
import { Storage } from '@ionic/storage-angular';
import { HttpClient } from '@angular/common/http';
import { take } from 'rxjs/operators';
import { DataService } from '../data/data.service';
import { environment } from 'src/environments/environment';
@Injectable({
  providedIn: 'root',
})
export class FcmService {
  firebaseTopic: string = environment.firebaseTopic;

  user: any = {};

  constructor(
    private toastCtrl: ToastController,
    private navCtrl: NavController,
    private storage: Storage,
    private http: HttpClient,
    private dataService: DataService
  ) {}

  async initPush() {
    this.user = await this.storage.get('user');
    if (Capacitor.getPlatform() == 'web') return;
    await PushNotifications.requestPermissions();
    await PushNotifications.register();
    setTimeout(() => {
      this.notifications();
    }, 1000);
  }

  async subscriptionToUser() {
    this.user = await this.storage.get('user');
    if (this.user?._id)
      await FCM.subscribeTo({
        topic: `user-${this.user?._id}${this.firebaseTopic}`,
      });
  }

  async notifications() {
    await FCM.subscribeTo({ topic: `all${this.firebaseTopic}` });
    if (this.user?._id)
      await FCM.subscribeTo({
        topic: `user-${this.user?._id}${this.firebaseTopic}`,
      });

    PushNotifications.addListener(
      'pushNotificationReceived',
      async (notification) => {
        this.presentToast(notification);
      }
    );

    await PushNotifications.addListener(
      'pushNotificationActionPerformed',
      (notification) => {
        this.openNotification(notification.notification);
      }
    );
  }

  async unsubscribe() {
    if (Capacitor.getPlatform() == 'web') return;
    await FCM.unsubscribeFrom({ topic: `all${this.firebaseTopic}` });
    if (this.user?._id)
      await FCM.unsubscribeFrom({
        topic: `user-${this.user._id}${this.firebaseTopic}`,
      });
  }

  // Toast For Notification
  private async presentToast(notification: PushNotificationSchema) {
    const toast = await this.toastCtrl.create({
      header: notification.title,
      message: notification.body,
      position: 'top',
      duration: 3000,
    });
    this.sound();
    await toast.present();
    toast.addEventListener('click', async () => {
      this.openNotification(notification);
      await toast.dismiss();
    });
  }

  openNotification(notification: PushNotificationSchema): void {
    const data = notification?.data?.fcm
      ? JSON.parse(notification?.data?.fcm)
      : null;

    if (data?.orderId) {
      if (!this.user?._id && this.dataService.settings.loginRequired) return;
      this.dataService.params = {
        order: { _id: data.orderId },
        loadData: true,
      };
      this.navCtrl.navigateForward('/order-detail');
    }

    if (data?.productId) {
      this.dataService.params = {
        product: { _id: data.productId },
        loadData: true,
      };
      this.navCtrl.navigateForward('/product-details/' + data.productId);
    }

    if (data?.categoryId) {
      this.dataService.params = {
        category: { _id: data.categoryId },
        loadData: true,
      };
      this.navCtrl.navigateForward('/category/' + data.categoryId);
    }

    if (data?.offerId) {
      this.dataService.params = {
        offer: { _id: data.offerId },
        loadData: true,
      };
      this.navCtrl.navigateForward('/offer');
    }
  }

  // NotificationSound
  sound() {}

  postNotification(body: any) {
    this.http
      .post(`http://209.250.237.58:5006/fcm`, body)
      .pipe(take(1))
      .subscribe();
  }
}
